export default __webpack_public_path__ + "locales/vi/Translations.json?hash=d465e194faac3a09a59a7db0353e9df5";